export enum PositionMediaTypeEnum {
  TEXT = 'TEXT',
  IMAGE = 'IMAGE',
  REGULAR = 'REGULAR'
}
